import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  escalations: [],
  loading: false,
  error: null,
};

const escalationsSlice = createSlice({
  name: 'escalations',
  initialState,
  reducers: {
    fetchEscalationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEscalationsSuccess: (state, action) => {
      state.loading = false;
      state.escalations = action.payload;
    },
    fetchEscalationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resolveEscalation: (state, action) => {
      const index = state.escalations.findIndex(e => e.id === action.payload);
      if (index !== -1) {
        state.escalations[index].status = 'resolved';
      }
    },
  },
});

export const { fetchEscalationsStart, fetchEscalationsSuccess, fetchEscalationsFailure, resolveEscalation } = escalationsSlice.actions;
export default escalationsSlice.reducer;
